<ng-template #modal>
  <div class="modal-header">
    <div class="modal-header-title">
      <h4 class="modal-title pull-left">Solicitação</h4>
      <h5 class="modal-subtitle" *ngIf="solicitacao?.title || solicitacao?.description">
        {{solicitacao?.title ? solicitacao?.title : solicitacao?.description}}
      </h5>
    </div>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="solicitacao">
      <ul>
        <li>
          <div>Solicitante:</div> <span class="nome">{{solicitacao?.lockdown_resp}}</span>
        </li>
        <li *ngIf="solicitacao?.lockdown_dt">
          <div>Solicitado nova informação em:</div> {{solicitacao?.lockdown_dt}}
        </li>
      </ul>
      <hr>
    </div>
  </div>
</ng-template>
